module.exports = __webpack_public_path__ + "img/palmar-hotel-3jpg.4f6df5d6.jpg";